import * as actionType from "./constants";

const initialState = {
    getGroupStatusDataResponse: {},
    entityParams: {
        entity: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    addGroupStatusResponse: {},
    updateGroupStatusResponse: {},
    deleteGroupStatusResponse: {},
    getGroupStatusDropdwnResponse: { isLoading: false }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_GROUP_STATUS_DATA_REQUEST:
            return {
                ...state,
                getGroupStatusDataResponse: { isLoading: true }
            };
        case actionType.GET_GROUP_STATUS_DATA_SUCCESS:
            return {
                ...state,
                getGroupStatusDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_GROUP_STATUS_DATA_FAILURE:
            return {
                ...state,
                getGroupStatusDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_GROUP_STATUS_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_GROUP_STATUS_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.POST_GROUP_STATUS_REQUEST:
            return {
                ...state,
                addGroupStatusResponse: { isLoading: true }
            };
        case actionType.POST_GROUP_STATUS_SUCCESS:
            return {
                ...state,
                addGroupStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.POST_GROUP_STATUS_FAILURE:
            return {
                ...state,
                addGroupStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_GROUP_STATUS_REQUEST:
            return {
                ...state,
                updateGroupStatusResponse: { isLoading: true }
            };
        case actionType.UPDATE_GROUP_STATUS_SUCCESS:
            return {
                ...state,
                updateGroupStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_GROUP_STATUS_FAILURE:
            return {
                ...state,
                updateGroupStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.DELETE_GROUP_STATUS_REQUEST:
            return {
                ...state,
                deleteGroupStatusResponse: { isLoading: true }
            };
        case actionType.DELETE_GROUP_STATUS_SUCCESS:
            return {
                ...state,
                deleteGroupStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_GROUP_STATUS_FAILURE:
            return {
                ...state,
                deleteGroupStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.STATUS_GROUP_DROPDOWN_REQUEST:
            return {
                ...state,
                getGroupStatusDropdwnResponse: { isLoading: true }
            };
        case actionType.STATUS_GROUP_DROPDOWN_SUCCESS:
            return {
                ...state,
                getGroupStatusDropdwnResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.STATUS_GROUP_DROPDOWN_FAILURE:
            return {
                ...state,
                getGroupStatusDropdwnResponse: { isLoading: false, success: false, ...action.error }
            };
        default:
            return state;
    }
};
